import { HintsConfigType } from '@dokucoach/common-types';
import * as yup from 'yup';

export interface IHintsConfig {
  id: string;
  type: HintsConfigType | 'NONE';
  intervalNumber: number;
  nursingHomeId: string;
}

export interface ICreateHintsConfig {
  type: HintsConfigType | 'NONE';
  intervalNumber: number;
}

export interface IUpdateHintsConfig {
  id: string;
  intervalNumber: number;
}

export const HintsConfigSchema = yup.object({
  type: yup.mixed<HintsConfigType>().oneOf(Object.values(HintsConfigType)).required(),
  intervalNumber: yup.number().required(),
  nursingHomeId: yup.string().required(),
});
